// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ktgX","rootMobile":"styles_rootMobile__xLhO8"};